import React from 'react'
import { Button } from 'antd';
import { TwitterOutlined, FacebookFilled, WhatsAppOutlined, LinkOutlined } from '@ant-design/icons';


const size = 'large'

export default function ShareProduct({ type, productId }) {
    return (
        <div className="flex flex-col">
            <Button type="default" style={{borderRadius: 0, color: "#25D366"}} icon={<WhatsAppOutlined />} size={size} />
            <Button type="default" style={{borderRadius: 0, color: "#4267B2"}} icon={<FacebookFilled />} size={size} />
            <Button type="default" style={{borderRadius: 0, color: "#1DA1F2"}} icon={<TwitterOutlined />} size={size} />
            <Button type="default" style={{borderRadius: 0, color: "#006AFF"}} icon={<LinkOutlined />} size={size} />
        </div>
    )
}
